module.exports = __webpack_public_path__ + "static/homepage-illustration-resources-0173e348aad218c4e1aebf5065779a83.png";